/**
 * Definiciones de tipos relacionados con la gestión de archivos multimedia en la aplicación.
 * Incluye tipos para el estado de los archivos, referencias a los propietarios de los archivos, errores de validación y resúmenes de carga.
 */

/**
 * @description Define los posibles estados que un archivo puede tener durante su ciclo de vida en la aplicación, desde su creación hasta su carga y validación.
 * - Esto permite gestionar y mostrar el estado de los archivos de manera clara en la interfaz de usuario, facilitando la experiencia del usuario al interactuar con archivos multimedia.
 */
export type FileStatus =
  | 'pending'
  | 'loading'
  | 'uploaded'
  | 'loaded'
  | 'error';

/**
 * @description Define los posibles ámbitos o contextos en los que un archivo puede estar asociado dentro de la aplicación.
 * - Esto permite organizar y gestionar los archivos de manera más eficiente según su uso específico.
 */
export type FileScope =
  | 'registro-compra'
  // | 'orden-ingreso'
  // | 'orden-compra'
  // | 'orden-servicio'
  | 'tesoreria-egreso'
  | 'generic';

  /**
   * @description Define la estructura de una referencia a un propietario de archivo, que incluye el ámbito al que pertenece el archivo, el ID de la entidad asociada y cualquier metadato adicional relevante.
   * - Esto permite vincular los archivos multimedia con entidades específicas dentro de la aplicación, facilitando su gestión y recuperación según el contexto en el que se utilicen.
   */
  export interface FileOwnerRef {
  scope: FileScope;
  entityId: string;
  metadata?: Record<string, unknown>;
}

/**
 * @description Define la estructura de un error de validación de archivos, que incluye el nombre del archivo y un mensaje descriptivo del error encontrado durante el proceso de validación.
 * - Esto permite proporcionar retroalimentación clara y específica a los usuarios sobre cualquier problema con los archivos que están intentando cargar, mejorando la experiencia del usuario y facilitando la corrección de errores.
 */
export interface FileValidationError {
  fileName: string;
  message: string;
}

/**
 * @description Define la estructura de un resumen de carga de archivos, que incluye el número de archivos agregados, cargados, eliminados y con errores.
 * - Esto permite mostrar estadísticas sobre el proceso de carga de archivos, proporcionando una visión general del rendimiento y el estado de la operación.
 */
export interface UploadSummary {
  added: number;
  uploaded: number;
  deleted: number;
  errors: number;
}